import { apiGet, apiPut } from '.';
import { BrandMapping, BrandMappingKind } from '../../../server/types/brandMapping';

export async function getBrandMappings(
  brandId: string,
  kind?: BrandMappingKind
): Promise<BrandMapping[]> {
  const params = kind ? `?kind=${kind}` : '';

  return apiGet(`/brand/${brandId}/mappings${params}`);
}

export async function updateBrandMappings(
  brandId: string,
  mappings: BrandMapping[]
): Promise<BrandMapping[]> {
  return apiPut(`/brand/${brandId}/mappings`, mappings);
}
